import React from "react";
import { Link } from "react-router";
import { getCalendarDay } from "../../calendar/utils";
import { Padding } from "../../shared-components/Padding";
import { useSettings } from "../../utils/settings";
import { LegacyRubric } from "../pray/LegacyRubric";
import { LordsPrayer } from "../pray/LordsPrayer";
import { Rubric } from "../pray/Rubric";
import { Spacer } from "../pray/Spacer";
import { TextBlock } from "../pray/TextBlock";
import { LitanyLine } from "./LitanyLine";

export const LitanyPage: React.FC<{}> = () => {
    const { settings, setSetting } = useSettings();

    const date = new Date().getDate();
    const month = new Date().getMonth() + 1;
    const year = new Date().getFullYear();

    const day = getCalendarDay(year, month, date, true);

    return (
        <>
            <Padding>
                <div
                    style={{
                        fontWeight: "bold",
                        letterSpacing: 2,
                        textTransform: "uppercase",
                        fontSize: "140%",
                        paddingBottom: 4,
                        paddingTop: 32,
                        textAlign: "center",
                    }}
                >
                    The Litany
                </div>
            </Padding>
            <Rubric content="These petitions shall be sung kneeling or standing." />
            <Spacer />
            <LitanyLine
                firstText="O God the Fa_ther, of |heav'n:"
                secondText="have mer_cy up_on us mi_se_|ra_ble sin_ners."
                firstTone={["5", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="O God the Son, Re_dee_mer of the |world:"
                secondText="have mer_cy up_on us mi_se_|ra_ble sin_ners."
                firstTone={["5", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="O God the Ho_ly Ghost, pro_ceed_ing from the Fa_ther and the |Son:"
                secondText="have mer_cy up_on us mi_se_|ra_ble sin_ners."
                firstTone={["5", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="O ho_ly, bless_ed, and glor_ious Tri_ni_ty, three Per_sons and one |God:"
                secondText="have mer_cy up_on us mi_se_|ra_ble sin_ners."
                firstTone={["5", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="Re_mem_ber not, Lord, our of_fen_ces, nor the of_fen_ces of our fore_fa_thers; nei_ther take thou ven_geance of our sins: Spare us, good Lord, spare thy peo_ple, whom thou hast re_deemed with thy most precious blood, and be not an_gry with |us for ev_er."
                secondText="Spare |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="From all e_vil and mis_chief; from sin; from the crafts and ass_aults of the de_vil; from thy wrath, and from ev_er_last_|ing dam_na_tion,"
                secondText="Good |Lord de_li_ver us."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="From all blind_ness of heart; from pride, vain_glo_ry, and hy_po_cri_sy; from en_vy, hat_red, and ma_lice, and |all un_cha_ri_ta_ble_ness,"
                secondText="Good |Lord de_li_ver us."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="From for_ni_ca_tion, and all o_ther dead_ly sin; and from all the de_ceits of the world, the flesh, |and the de_vil,"
                secondText="Good |Lord de_li_ver us."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="From light_ning and tem_pest; from earth_quake, fire, and flood; from plague, pes_ti_lence, and fa_mine; from bat_tle and mur_der, and from |sud_den death,"
                secondText="Good |Lord de_li_ver us."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="From all se_di_tion, pri_vy con_spi_ra_cy, and re_bell_ion; from all false doc_trine, he_re_sy, and sch_ism; from hard_ness of heart, and con_tempt of thy Word |and Com_mand_ment,"
                secondText="Good |Lord de_li_ver us."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="By the my_ste_ry of thy ho_ly In_car_na_tion; by thy ho_ly Na_ti_vi_ty and Cir_cum_ci_sion; by thy Bap_tism, Fast_ing, |and Temp_ta_tion,"
                secondText="Good |Lord de_li_ver us."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="By thine A_go_ny and Bloo_dy Sweat; by thy Cross and Pass_ion; by thy pre_cious Death and Bu_ri_al; by thy glor_ious Re_sur_rec_tion and As_cen_sion, and by the Comi_ng of the |Ho_ly Ghost,"
                secondText="Good |Lord de_li_ver us."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="In all time of our tri_bu_la_tion; in all time of our wealth; in the hour of death, and in the |day of judg_ment,"
                secondText="Good |Lord de_li_ver us."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="We sin_ners do be_seech thee to hear us, O Lord God; and that it may please thee to rule and go_vern thy ho_ly Church u_ni_ver_sal in |the right way;"
                secondText="We be_seech thee to hear |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            {settings.monarch === "yes" ? (
                <>
                    <LitanyLine
                        firstText="That it may please thee to keep and strength_en in the true wor_shipp_ing of thee, in right_eous_ness and ho_li_ness of life, thy Ser_vant Charles our most gra_cious |King and Go_ver_nor;"
                        secondText="We be_seech thee to hear |us, good Lord."
                        firstTone={["5", "4", "3", "6"]}
                        secondTone={["5", "3", "4", "5"]}
                    />
                    <LitanyLine
                        firstText="That it may please thee to rule his heart in thy faith, fear, and love, and that he may ev_er_more have af_fi_ance in thee, and ev_er seek thy hon_|our and glo_ry;"
                        secondText="We be_seech thee to hear |us, good Lord."
                        firstTone={["5", "4", "3", "6"]}
                        secondTone={["5", "3", "4", "5"]}
                    />
                    <LitanyLine
                        firstText="That it may please thee to be his de_fen_der and keep_er, giv_ing him the vic_to_ry o_ver |all his e_ne_mies;"
                        secondText="We be_seech thee to hear |us, good Lord."
                        firstTone={["5", "4", "3", "6"]}
                        secondTone={["5", "3", "4", "5"]}
                    />
                    <LitanyLine
                        firstText="That it may please thee to bless and pre_serve Wil_li_am Prince of Wales, and all the |Ro_yal Fa_mi_ly;"
                        secondText="We be_seech thee to hear |us, good Lord."
                        firstTone={["5", "4", "3", "6"]}
                        secondTone={["5", "3", "4", "5"]}
                    />
                </>
            ) : (
                <></>
            )}
            <LitanyLine
                firstText="That it may please thee to il_lu_min_ate all Bish_ops, Priests, and Dea_cons, with true know_ledge and un_der_stand_ing of thy Word; and that both by their preach_ing and liv_ing they may set it forth, and show |it ac_cor_ding_ly;"
                secondText="We be_seech thee to hear |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="That it may please thee to en_due the Lords of the Coun_cil, and all the No_bi_li_ty, with grace, wis_dom, and |un_der_stand_ing;"
                secondText="We be_seech thee to hear |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="That it may please thee to bless and keep the Ma_gi_strates, giv_ing them grace to ex_e_cute just_ice, and to |main_tain truth;"
                secondText="We be_seech thee to hear |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="That it may please thee to bless and keep |all thy peo_ple;"
                secondText="We be_seech thee to hear |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="That it may please thee to give to all na_tions u_ni_ty, |peace, and con_cord;"
                secondText="We be_seech thee to hear |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="That it may please thee to give us a heart to love and dread thee, and di_li_gent_ly to live af_ter |thy com_mand_ments;"
                secondText="We be_seech thee to hear |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="That it may please thee to give to all thy peo_ple in_crease of grace to hear meek_ly thy Word, and to re_ceive it with pure af_fec_tion, and to bring forth the fruits |of the Spi_rit;"
                secondText="We be_seech thee to hear |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="That it may please thee to bring in_to the way of truth all such as have erred, and |are de_ceived;"
                secondText="We be_seech thee to hear |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="That it may please thee to strength_en such as do stand; and to com_fort and help the weak-_hearted; and to raise up those who fall; and fi_na_lly to beat down Sa_tan un_|der our feet;"
                secondText="We be_seech thee to hear |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="That it may please thee to suc_cour, help, and com_fort, all who are in dan_ger, ne_ces_si_ty, and |tri_bu_la_tion;"
                secondText="We be_seech thee to hear |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="That it may please thee to pre_serve all who tra_vel by land, by water, all wo_men la_bour_ing of child, all sick per_sons, and young child_ren; and to show thy pi_ty up_on all pri_so_|ners and cap_tives;"
                secondText="We be_seech thee to hear |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="That it may please thee to de_fend, and pro_vide for, the fa_ther_less child_ren, and wi_dows, and all who are de_so_late |and op_pressed;"
                secondText="We be_seech thee to hear |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="That it may please thee to have mer_cy up_|on all men;"
                secondText="We be_seech thee to hear |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="That it may please thee to for_give our e_ne_mies, per_se_cu_tors, and slan_der_ers, and to |turn their hearts;"
                secondText="We be_seech thee to hear |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="That it may please thee to give and pre_serve to our use the kindly fruits of the earth, so that in due time we |may en_joy them;"
                secondText="We be_seech thee to hear |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="That it may please thee to give us true re_pen_tance; to for_give us all our sins, neg_li_gen_ces, and ig_no_ran_ces; and to en_due us with the grace of thy Ho_ly Spi_rit to am_end our lives ac_cor_ding to thy |ho_ly Word;"
                secondText="We be_seech thee to hear |us, good Lord."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="Son of God: we be_seech |thee to hear us."
                secondText="Son of God: we be_seech |thee to hear us."
                firstTone={["5", "3", "4", "5"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="O Lamb of God: that tak_est a_way the sins |of the world;"
                secondText="Grant |us thy peace."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="O Lamb of God: that tak_est a_way the sins |of the world;"
                secondText="Have mer_|cy up_on us."
                firstTone={["5", "4", "3", "6"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="|O Christ, hear us."
                secondText="|O Christ, hear us."
                firstTone={["5", "3", "4", "5"]}
                secondTone={["5", "3", "4", "5"]}
            />{" "}
            <LitanyLine
                firstText="Lord, have mer_|cy up_on us."
                secondText="Lord, have mer_|cy up_on us."
                firstTone={["5", "3", "4", "5"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="Christ, have mer_|cy up_on us."
                secondText="Christ, have mer_|cy up_on us."
                firstTone={["5", "3", "4", "5"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <LitanyLine
                firstText="Lord, have mer_|cy up_on us."
                secondText="Lord, have mer_|cy up_on us."
                firstTone={["5", "3", "4", "5"]}
                secondTone={["5", "3", "4", "5"]}
            />
            <Spacer />
            <Rubric content="All shall sing together the **Lord's Prayer.**" />
            <LordsPrayer />
            <Spacer />
            <LitanyLine
                firstText="O Lord, deal not with us ac_cor_ding to |our sins."
                secondText="Nei_ther re_ward us ac_cord_ing to our i_ni_|qui_ties."
                firstTone={["5", "3", "4"]}
                secondTone={["5", "3"]}
            />
            <Spacer />
            <Rubric
                content="The following prayers shall be sung by the Officiant on one
                note, ending as follows:"
            />
            <LitanyLine
                firstText=""
                secondText="O God . . . through Je_sus Christ |our Lord"
                firstTone={["5", "5"]}
                secondTone={["5", "3", "4"]}
            />
            <TextBlock
                content="O God, merciful Father, that despisest not the sighing of a
                contrite heart, nor the desire of such as are sorrowful;
                Mercifully assist our prayers which we make before thee in all
                our troubles and adversities, whensoever they oppress us; and
                graciously hear us, that those evils which the craft and
                subtilty of the devil or man worketh be brought to nought; and
                by the providence of thy goodness they may be dispersed; that we
                thy servants, being hurt by no persecutions, may evermore give
                thanks unto thee in thy holy Church; through Jesus Christ our
                Lord."
            />
            <Spacer />
            <LitanyLine
                firstText=""
                secondText="O Lord, a_rise, help us, and de_li_ver us for thy |Name's sake."
                firstTone={["5"]}
                secondTone={["5", "3", "4"]}
            />
            <Spacer />
            <TextBlock
                content="O God, we have heard with our ears, and our fathers have
                declared unto us, the noble works that thou didst in their days,
                and in the old time before them."
            />
            <Spacer />
            <LitanyLine
                firstText=""
                secondText="O Lord, a_rise, help us, and de_li_ver us for thine hon_|our."
                firstTone={["5"]}
                secondTone={["5", "3"]}
            />
            <LitanyLine
                firstText="Glo_ry be to the Fa_ther, and to the Son, and to the Ho_|ly Ghost;"
                secondText="As it was in the be_ginn_ing, is now, and e_ver shall be, world with_|out end. A_men."
                firstTone={["5", "3", "4"]}
                secondTone={["5", "3", "4", "4", "5"]}
            />
            <LitanyLine
                firstText="From our e_ne_mies de_fend us, |O Christ."
                secondText="Gra_cious_ly look up_on our aff_lic_|tions."
                firstTone={["5", "3", "4"]}
                secondTone={["5", "3"]}
            />
            <LitanyLine
                firstText="Pi_ti_ful_ly be_hold the sor_rows of |our hearts."
                secondText="Mer_ci_ful_ly for_give the sins of thy peo_|ple."
                firstTone={["5", "3", "4"]}
                secondTone={["5", "3"]}
            />
            <LitanyLine
                firstText="Fa_vou_ra_bly with me_rcy hear our |pray'rs."
                secondText="O Son of Da_vid, have mer_cy up_|on us."
                firstTone={["5", "3"]}
                secondTone={["5", "3", "4"]}
            />
            <LitanyLine
                firstText="Both now and e_ver vouch_safe to hear us, |O Christ."
                secondText="Gra_cious_ly hear us, O Christ; gra_cious_ly hear us, O |Lord Christ."
                firstTone={["5", "3", "4"]}
                secondTone={["5", "3", "4"]}
            />
            <LitanyLine
                firstText="O Lord, let thy mer_cy be showed up_|on us;"
                secondText="As we do put our trust |in thee."
                firstTone={["5", "3", "4"]}
                secondTone={["5", "3", "4"]}
            />
            <Spacer />
            <TextBlock
                content="We humbly beseech thee, O Father, mercifully to look upon our
                infirmities; and, for the glory of thy Name, turn from us all
                those evils that we most justly have deserved; and grant, that
                in all our troubles we may put our whole trust and confidence in
                thy mercy, and evermore serve thee in holiness and pureness of
                living, to thy honour and glory; through our only Mediator and
                Advocate, Jesus Christ our Lord. **Amen.**"
            />
            <Spacer />
            <Rubric content="The Officiant may say this **Prayer_of_Saint_John_Chrysostom.**" />
            <TextBlock
                content="Almighty God, who hast given us grace at this time with one
                accord to make our common supplications unto thee; and dost
                promise, that when two or three are gathered together in thy
                Name thou wilt grant their requests: Fulfil now, O Lord, the
                desires and petitions of thy servants, as may be most expedient
                for them; granting us in this world knowledge of thy truth, and
                in the world to come life everlasting. **Amen.**"
            />
            {day.label === "ash-wednesday" ? (
                <>
                    <Spacer />
                    <LegacyRubric>
                        <strong>ASH WEDNESDAY</strong>
                        <br />
                        It is appropriate to conclude with{" "}
                        <strong style={{ textDecoration: "underline" }}>
                            <Link to="/pray/commination">
                                The&nbsp;Commination
                            </Link>
                        </strong>
                        .
                    </LegacyRubric>
                    <Spacer />
                </>
            ) : (
                <></>
            )}
            <Rubric content="The Officiant shall say **The_Grace.**"></Rubric>
            <TextBlock
                content="The grace of our Lord Jesus Christ, and the love of God, and the
                fellowship of the Holy Ghost, be with us all evermore. **Amen.**"
            />
            <Spacer big />
        </>
    );
};
